/**
 * How /rate writes a dollar figure. One definition, because two would drift.
 *
 * 🔴 IT LIVED IN GroupCard.jsx AND IT IS NOT A COMPONENT'S BUSINESS. It moved
 * here the moment a util needed it: roomSource.js builds a sentence carrying the
 * room's average surplus, and a util importing a React component to format a
 * number would drag the whole component tree into its dependency chain. The
 * cards still import it under the same names — GroupCard re-exports — so nothing
 * about how the page reads changed.
 *
 * Whole dollars stay whole and everything else takes exactly one decimal: a
 * league's prices are integers, so "$44" is the common case and the tenth only
 * appears on a figure that really has one, like a surplus total or an average.
 */

export function money(v) {
  if (v == null) return "";
  const sign = v < 0 ? "-" : "";
  const a = Math.abs(v);
  return `${sign}$${Number.isInteger(a) ? a : a.toFixed(1)}`;
}

export function signedMoney(v) {
  return v > 0 ? `+${money(v)}` : money(v);
}
